import React from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { MDSTypography, MDSButton } from '@marqvision/mds-v2';

const useStyles = makeStyles(({ _raw_color }) => ({
  wrapper: {
    width: '100%',
    height: '100%',
    minHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    paddingBottom: '24px',
  },
  errorCode: {
    fontSize: '160px !important',
    fontWeight: '900 !important' as 'bold',
    lineHeight: '1.3 !important',
    color: `${_raw_color.blue100} !important`,
  },
}));

export const NotFoundBox = (): React.ReactNode => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className={classes.wrapper}>
      <MDSTypography variant="title" size="2xl" weight="semibold" className={classes.errorCode}>
        404
      </MDSTypography>
      <div className={classes.textWrapper}>
        <MDSTypography variant="title" size="2xl" weight="semibold">
          Page not found
        </MDSTypography>
        <MDSTypography variant="body" size="m" weight="regular">
          The page you are looking for does not exist. It might have been moved or deleted.
        </MDSTypography>
      </div>
      <MDSButton size="large" onClick={handleBackToHome}>
        Back to Home
      </MDSButton>
    </div>
  );
};
